/**
 * ログインとフォローの状態列挙
 */
export const userStatus = {
  loginedAndFollowing: 'LOGINED_AND_FOLLOWING',
  loginedNotFollowing: 'LOGINED_NOT_FOLLOWING',
  notLogined: 'NOT_LOGINED'
};

/**
 * ログインとフォローのステータスを受け取った状態から返す
 *
 * @param {boolean} status フォローしてるかどうか
 */
export function getStatus (isLogined, status) {
  if (isLogined && status) {
    return userStatus.loginedAndFollowing;
  } else if (isLogined && !status) {
    return userStatus.loginedNotFollowing;
  } else {
    return userStatus.notLogined;
  }
}
